export const WithdrawApiRoute = {
  Request: (): string => '/dashboard/balance/withdraw/request',
  Confirm: (): string => '/dashboard/balance/withdraw/confirm',
};
